import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Logo from '../../assets/Logo/LS-logo.png';
import "./appAdminHeader.css";

const AppHeader = ({ setMenuToggle, setLoginStatus }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    setLoginStatus(false);
    Cookies.remove('loginStatus');
    navigate("/");
  };

  return (
    <header className="admin-app-header shadow-md">
      <div className="admin-header-content">
        <div className="logo-section" onClick={() => navigate("/dashboard")}>
          <img src={Logo} alt="Logo" className="logo-img" />
        </div>

        <div className="admin-buttons">
          <button
            className="admin-btn logout-btn"
            onClick={handleLogout}
          >
            <i className="fas fa-sign-out-alt" style={{ marginRight: "8px" }}></i>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
